import Swal from 'sweetalert2'

export const swal = {

  prompt: (options) => {
    if (options.init) options.init()
    return Swal.fire({
      title: options.title,
      input: 'text',
      inputAttributes: { autocapitalize: 'off', placeholder: options.placeholder || '' },
      inputValue: options.inputValue || '',
      confirmButtonText: '確定',
      confirmButtonColor: '#5599FF',
      showCancelButton: true,
      cancelButtonText: '取消',
      showLoaderOnConfirm: true,
      preConfirm: options.preConfirm
    })
  },

  confirm: (title, preConfirm = () => {}) => {
    return Swal.fire({
      title: title,
      confirmButtonText: '確定',
      confirmButtonColor: '#5599FF',
      showCancelButton: true,
      cancelButtonText: '取消',
      preConfirm: preConfirm
    })
  },

  alertSuccess: (title, preConfirm = () => {}) => {
    return Swal.fire({
      title: title,
      icon: 'success',
      confirmButtonText: '確定',
      confirmButtonColor: '#5599FF',
      preConfirm: preConfirm
    })
  },

  alertError: (title, preConfirm = () => {}) => {
    return Swal.fire({
      title: title,
      icon: 'error',
      confirmButtonText: '確定',
      confirmButtonColor: '#5599FF',
      preConfirm: preConfirm
    })
  },

  alertErrorText: (title, text, preConfirm = () => {}) => {
    return Swal.fire({
      title: title,
      text: text,
      icon: 'error',
      confirmButtonText: '確定',
      confirmButtonColor: '#5599FF',
      preConfirm: preConfirm || (() => {})
    })
  },

  alertLoading: (title = '請稍候...') => {
    Swal.fire({
      title: title,
      allowOutsideClick: false,  // 禁止點擊背景關閉
      allowEscapeKey: false,     // 禁止按下 ESC 關閉
      allowEnterKey: false,      // 禁止按下 Enter 關閉
      didOpen: () => Swal.showLoading()
    })
  },

  alertInfo: (title, text, preConfirm = () => {}) => {
    return Swal.fire({
      title: title,
      text: text,
      icon: 'info',
      confirmButtonText: '確定',
      confirmButtonColor: '#5599FF',
      preConfirm: preConfirm
    })
  },

  close: () => Swal.close()

}